import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RuleTranslator } from '@cbridge-packages/rule';
import { OrderLifetimeRuleAction } from '../orderLifetimeRule.action';
import { OrderLifetimeRuleTranslator } from '../orderLifetimeRule.translator';

type IDependencies = IClientApiDependencySegment;

export const validateOrderLifetimeRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(OrderLifetimeRuleAction.validate.started),
  switchMap((params) => {
    const rules = params.map(OrderLifetimeRuleTranslator.toApi);
    return dependencies.api.validateOrderLifetimeRules({ rules }).pipe(
      mergeMap((response) => {
        return [
          OrderLifetimeRuleAction.validate.done({ params, result: (response.rules ?? []).map(RuleTranslator.fromApiValidation) }),
        ];
      }),
      catchApiError((error) => {
        return [
          OrderLifetimeRuleAction.validate.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
